import React, { useEffect, useState } from 'react';
import './style.scss';
import { Header } from '../download-center/download-center-header';
import tipsIcon from '../../assets/svg/tips-icon.svg';
import priceHeader from '../../assets/img/price-header.png';
import simulationScenarioIcon from '../../assets/svg/simulation-scenario-icon.svg';
import servicePurchaseIcon from '../../assets/svg/service-purchase-icon.svg';
import classNames from 'classnames';
import { getServiceModel, getCalculateResult } from '../../api/price';
import {
  ICalculateRes,
  IngameServiceModel,
  CalculateFreeServices,
  IPriceSelectBody,
} from '../../model/api-modules/price-calculator';
import { Form, InputNumber, Select, Tooltip } from 'antd';
import { ServiceSelectForm } from './services-select';
import { messageError } from '../../components/message';
import menuDown from '../../assets/svg/menu-down.svg';
import getFormatMessage from '../../locales/get-format-message';
import { SERVICES_LIST, REGION_OPTIONS, TYPE_OPTIONS } from './service-list';

export const PriceCalculateRouter = () => {
  const [supportServicesList, setSupportServicesList] = useState<string[]>([]);
  const [selectedServices, setSelectedServices] = useState<{
    [key: string]: string[];
  }>({});
  const [preFreeServices, setPreFreeServices] = useState<string[]>([]);
  const [calculateResult, setCalculateResult] = useState<ICalculateRes | null>(
    null
  );
  const [checkRequired, setCheckRequired] = useState<boolean>(false);
  const [isSelectIngame, setIsSelectIngame] = useState<boolean>(false);
  const [calculateLoading, setCalculateLoading] = useState<boolean>(false);
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [formValue, setFormValue] = useState<IPriceSelectBody>({});
  const [selectForm] = Form.useForm();

  useEffect(() => {
    getServiceModelList();
  }, []);

  useEffect(() => {
    checkRequiredField();
    checkSelectIngame();
    deleteFreeServices();
  }, [selectedServices]);

  const getServiceModelList = async () => {
    const res = await getServiceModel();
    if (res) {
      const supportServices: string[] = [];
      res.list?.length !== 0 &&
        res.list.forEach((item) => {
          const itemServices = item.ModelRelationServices || [];
          if (itemServices.length !== 0) {
            itemServices.forEach((it) => {
              if (supportServices.indexOf(it) === -1) {
                supportServices.push(it);
              }
            });
          }
        });
      setSupportServicesList(supportServices);
    }
  };

  const renderServiceSelectForm = () => {
    return (
      <ServiceSelectForm
        selectedServices={selectedServices}
        setSelectedServices={setSelectedServices}
        supportServicesList={supportServicesList}
        isSelectIngame={isSelectIngame}
      />
    );
  };

  const checkRequiredField = (newFormValue?: IPriceSelectBody) => {
    let checkPass = true;
    const values = newFormValue || formValue;
    const mergedServices = Object.values(selectedServices).reduce(
      (acc, curr) => acc.concat(curr),
      []
    );
    if (!values.area) {
      checkPass = false;
    }
    if (!values.gameType) {
      checkPass = false;
    }
    if (!values.playerCount && values.playerCount !== 0) {
      checkPass = false;
    }
    if (!values.pcu && values.pcu !== 0) {
      checkPass = false;
    }
    if (!values.dau && values.dau !== 0) {
      checkPass = false;
    }
    if (!values.mau && values.mau !== 0) {
      checkPass = false;
    }
    if (mergedServices.length === 0) {
      checkPass = false;
    }
    setCheckRequired(checkPass);
  };

  const clickCalculate = async () => {
    const values: any = Object.assign({}, formValue);
    const mergedServices = Object.values(selectedServices).reduce(
      (acc, curr) => acc.concat(curr),
      []
    );
    if (!values.area) {
      return;
    }
    if (!values.gameType) {
      return;
    }
    if (!values.playerCount && values.playerCount !== 0) {
      return;
    }
    if (!values.pcu && values.pcu !== 0) {
      return;
    }
    if (!values.dau && values.dau !== 0) {
      return;
    }
    if (!values.mau && values.mau !== 0) {
      return;
    }
    if (mergedServices.length === 0) {
      return;
    }
    setCalculateLoading(true);
    const res = await getCalculateResult({
      ...values,
      services: mergedServices,
    });
    setCalculateLoading(false);
    if (res) {
      setShowDetails(true);
      setCalculateResult(res);
      const servicesNameArr: string[] = res.services.map(
        (service) => service.name
      );
      const filteredList = mergedServices.filter(
        (service) => !servicesNameArr.includes(service)
      );
      setPreFreeServices(filteredList);
      return;
    }
    messageError('Estimation failure!');
  };

  const getCalculateTotal = () => {
    let calculateTotal = 0;
    if (calculateResult) {
      calculateResult.services.forEach((item) => {
        calculateTotal += item.fee;
      });
    }
    return formatPrice(calculateTotal || 0.0);
  };

  const checkSelectIngame = () => {
    const ingameServices: string[] = [];
    for (const value of Object.values(IngameServiceModel)) {
      ingameServices.push(value);
    }
    const mergedServices = Object.values(selectedServices).reduce(
      (acc, curr) => acc.concat(curr),
      []
    );
    const selectIngame = mergedServices.some((item) =>
      ingameServices.includes(item)
    );
    setIsSelectIngame(selectIngame);
    return selectIngame;
  };

  // 选择的服务发生改变时判断是否当前选中了ingame付费服务，如果没有并且选择的服务包含免费服务则删除
  const deleteFreeServices = () => {
    const freeServices: string[] = [];
    for (const value of Object.values(CalculateFreeServices)) {
      freeServices.push(value);
    }
    const mergedServices = Object.values(selectedServices).reduce(
      (acc, curr) => acc.concat(curr),
      []
    );
    if (
      !checkSelectIngame() &&
      mergedServices.some((item) => freeServices.includes(item))
    ) {
      const services = Object.assign({}, selectedServices);
      Object.keys(services).forEach((category) => {
        services[category] = services[category].filter(
          (service) => !freeServices.includes(service)
        );
      });
      setSelectedServices(services);
    }
  };

  const formatPrice = (price: number) => {
    return price.toLocaleString('zh-CN');
  };

  const getLabelByValue = (value: string) => {
    for (const category of SERVICES_LIST) {
      const foundOption = category.options.find(
        (option) => option.value === value
      );
      if (foundOption) {
        return foundOption.label;
      }
    }
    return value;
  };

  const changeValue = (e: any, key: string) => {
    const newFormValue = {
      ...formValue,
      [key]: e,
    };
    setFormValue(newFormValue);
    checkRequiredField(newFormValue);
  };

  return (
    <div className="price-calculate">
      <Header />
      <div className="title-box">
        <div className="title-content-box">
          <div className="title-ingame">InGame</div>
          <div className="title-price">{getFormatMessage('price_calc')}</div>
          <div className="title-tips">
            <img src={tipsIcon} />
            <span>{getFormatMessage('price_tips')}</span>
          </div>
        </div>
      </div>
      <div className="price-content-box">
        <img src={priceHeader} className="content-header" />
        <div className="content-box">
          <div className="price-select-box">
            <div className="simulation-title">
              <img src={simulationScenarioIcon} />
              <span>{getFormatMessage('price_simulation')}</span>
            </div>
            <div className="simulation-tips">
              {getFormatMessage('price_simulation_tips')}
            </div>
            <div>
              <Form
                form={selectForm}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}
              >
                <Form.Item name="area" style={{ marginBottom: '20px' }}>
                  <span className="price-label">
                    {getFormatMessage('price_region')}
                  </span>
                  <Select
                    style={{ width: '374px' }}
                    options={REGION_OPTIONS}
                    onChange={(e) => changeValue(e, 'area')}
                  />
                </Form.Item>
                <Form.Item name="gameType" style={{ marginBottom: '20px' }}>
                  <span className="price-label">
                    {getFormatMessage('price_game_type')}
                  </span>
                  <Select
                    style={{ width: '374px' }}
                    options={TYPE_OPTIONS}
                    virtual={false}
                    onChange={(e) => changeValue(e, 'gameType')}
                  />
                </Form.Item>
                <Form.Item name="playerCount" style={{ marginBottom: '20px' }}>
                  <span className="price-label">
                    {getFormatMessage('price_players_num')}
                  </span>
                  <InputNumber
                    style={{ width: '374px' }}
                    onChange={(e) => changeValue(e, 'playerCount')}
                    min={0}
                    max={100000000000}
                  />
                </Form.Item>
                <Form.Item name="pcu" style={{ marginBottom: '20px' }}>
                  <span className="price-label">PCU</span>
                  <InputNumber
                    style={{ width: '374px' }}
                    onChange={(e) => changeValue(e, 'pcu')}
                    min={0}
                    max={100000000000}
                  />
                </Form.Item>
                <Form.Item name="dau" style={{ marginBottom: '20px' }}>
                  <span className="price-label">DAU</span>
                  <InputNumber
                    style={{ width: '374px' }}
                    onChange={(e) => changeValue(e, 'dau')}
                    min={0}
                    max={100000000000}
                  />
                </Form.Item>
                <Form.Item name="mau" style={{ marginBottom: '20px' }}>
                  <span className="price-label">MAU</span>
                  <InputNumber
                    style={{ width: '374px' }}
                    onChange={(e) => changeValue(e, 'mau')}
                    min={0}
                    max={100000000000}
                  />
                </Form.Item>
              </Form>
            </div>
            <div className="simulation-title service-title">
              <img src={servicePurchaseIcon} />
              <span>{getFormatMessage('price_service_pur')}</span>
            </div>
            <div>{renderServiceSelectForm()}</div>
          </div>
        </div>
        <div className="price-bottom-box">
          <div
            className={classNames(
              'price-btn-box',
              showDetails ? 'price-btn-box-show-detail' : ''
            )}
          >
            {!checkRequired ? (
              <Tooltip title={getFormatMessage('price_service_tips')}>
                <div
                  className={classNames(
                    'price-btn-left',
                    calculateLoading || !checkRequired
                      ? 'price-btn-left-disable'
                      : ''
                  )}
                  onClick={clickCalculate}
                >
                  {!calculateResult
                    ? getFormatMessage('price_btn_calc')
                    : getFormatMessage('price_btn_calc_re')}
                </div>
              </Tooltip>
            ) : (
              <div
                className={classNames(
                  'price-btn-left',
                  calculateLoading || !checkRequired
                    ? 'price-btn-left-disable'
                    : ''
                )}
                onClick={clickCalculate}
              >
                {!calculateResult
                  ? getFormatMessage('price_btn_calc')
                  : getFormatMessage('price_btn_calc_re')}
              </div>
            )}
            <div className="price-btn-right">
              <div
                className={classNames(
                  'price-btn-right-cost',
                  !calculateResult ? '' : 'price-btn-right-cost-result'
                )}
              >
                <span className="cost-left">
                  {getFormatMessage('price_estimated_cost')}
                </span>
                <span className="cost-right">{`¥ ${getCalculateTotal()}`}</span>
              </div>
              {calculateResult && (
                <div className="cost-tips">
                  <div>{getFormatMessage('price_cost_tips')}</div>
                  <div
                    className="cost-tips-view"
                    onClick={() => setShowDetails(!showDetails)}
                  >
                    <span>
                      {showDetails
                        ? getFormatMessage('price_pack_up_detail')
                        : getFormatMessage('price_view_detail')}
                    </span>
                    <img
                      src={menuDown}
                      className={showDetails ? 'pack-up-detail-img' : ''}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          {showDetails && (
            <div className="cost-tabel-box">
              <div className="cost-details-line"></div>
              <div className="cost-tabel">
                <div className="cost-tabel-header">
                  <div className="cost-tabel-col cost-tabel-col-one">
                    {getFormatMessage('price_service')}
                  </div>
                  <div className="cost-tabel-col cost-tabel-col-two">
                    {getFormatMessage('price_estimated')}
                  </div>
                  <div className="cost-tabel-col cost-tabel-col-three">
                    {getFormatMessage('price_description')}
                  </div>
                </div>
                <div className="cost-tabel-header cost-tabel-row cost-tabel-row-first">
                  <div className="cost-tabel-col cost-tabel-col-one">
                    {getFormatMessage('price_subscription_fees')}
                  </div>
                  <div className="cost-tabel-col cost-tabel-col-two">{`¥ ${formatPrice(
                    calculateResult?.subscriptionFee || 0
                  )}`}</div>
                  <div className="cost-tabel-col cost-tabel-col-three">
                    {getFormatMessage('price_subscription_fees_tips')}
                  </div>
                </div>
                {calculateResult?.services.length !== 0 &&
                  calculateResult?.services.map((item) => {
                    return (
                      <div className="cost-tabel-header cost-tabel-row">
                        <div className="cost-tabel-col cost-tabel-col-one">
                          {getLabelByValue(item.name)}
                        </div>
                        <div className="cost-tabel-col cost-tabel-col-two">{`¥ ${formatPrice(
                          item.fee || 0
                        )}`}</div>
                        <div className="cost-tabel-col cost-tabel-col-three"></div>
                      </div>
                    );
                  })}
                {preFreeServices.map((item) => {
                  return (
                    <div className="cost-tabel-header cost-tabel-row">
                      <div className="cost-tabel-col cost-tabel-col-one">
                        {getLabelByValue(item)}
                      </div>
                      <div className="cost-tabel-col cost-tabel-col-two">
                        ¥ 0
                      </div>
                      <div className="cost-tabel-col cost-tabel-col-three"></div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
